/**
 * Reformats a date string from YYYY-MM-DD to DD-MM-YYYY format
 * @param date - Date string in YYYY-MM-DD format
 * @returns Date string in DD-MM-YYYY format or undefined if input is invalid
 */
const dateFormat = (date: string | null | undefined): string | undefined => {
  if (!date) return undefined
  const d = date.split('-')
  if (d.length !== 3) return undefined

  return `${d[2]}-${d[1]}-${d[0]}`
}

export default dateFormat
